import InviteLandingPage from "./InviteLandingPage";
export default InviteLandingPage;
